export default {
  //文章详情页面
  SET_ARCHIVE_DETAIL: (state, { detail }) => {
    state.archiveDetail = detail;
  },
  //作品详情页面
  SET_PRODUCTION_DETAIL: (state, { detail }) => {
    state.productionDetail = detail;
  },
  //作品列表页面 --根据类型ID
  SET_WORKS_META: (state, { detail }) => {
    state.worksMeta = detail;
  },
  //作品列表页面
  SET_WORKS_LIST: (state, { list }) => {
    state.worksList = list;
  },
  //作品活动征集详情页面
  SET_ACTIVITY_INFO_DETAIL: (state, { detail }) => {
    state.activityInfoDetail = detail;
  },

  SET_ACTIVITY_LIST: (state, { detail }) => {
    state.activityList = detail;
  },
  //个人中心
  SET_USER_DETAIL: (state, { detail }) => {
    state.userDetail = detail;
  },
  // //微博Tokken
  // SET_WEIBO_TOKEN: (state, { detail }) => {
  //   state.weiboToken = detail;
  // },

  //直播详情页面
  SET_LIVE_DETAIL: (state, { detail }) => {
    state.liveDetail = detail;
  },
  //点播页面
  SET_VIDEO_DETAIL: (state, { detail }) => {
    state.videoDetail = detail;
  },
  //demo
  SET_TOPICS_LIST: (state, { list,pageNo }) => {
    //state.topicsList = list;

    state.topicsList = list//.slice((pageNo - 1) * 9, pageNo * 9)
    state.topicsListTotal = list.length
  },
  SET_TOPIC_DETAIL: (state, { detail }) => {
    state.topicDetail = detail;
  },
  //模型详情页面
  SET_MODEL_DETAIL: (state, { detail }) => {
    state.modelDetail = detail;
  },
//剧集详情页面
  SET_SECTION_DETAIL: (state, { detail }) => {
    state.sectionDetail = detail;
  },
  //问题详情页面
  SET_QUESTION_DETAIL: (state, { detail }) => {
    state.questionDetail = detail;
  },
//专栏列表
  SET_COLUMN_META: (state, { detail }) => {
    state.columnMeta = detail;
  },
  SET_COLUMN_TYPE_META: (state, { detail }) => {
    state.columnTypeMeta = detail;
  },
  //文章列表
  SET_ARCHIVE_LIST: (state, { detail }) => {
    state.davartList = detail;
  },


  /**
   * 新版
   */

  //首页(网站)
  SET_NEW_INDEX_PRODUCTION_LIST: (state, { list }) => {
    state.newIndexProductionList = list;
  },
  SET_NEW_INDEX_STORY_LIST: (state, { list }) => {
    state.newIndexStoryList = list;
  },
  SET_NEW_INDEX_COURSE_LIST: (state, { list }) => {
    state.newIndexCourseList = list;
  },

  //首页(动画短片)
  SET_NEW_INDEX_VIDEO_PRODUCTION_ONE_LIST: (state, { list }) => {
    state.newIndexVideoProductionOneList = list;
  },
  SET_NEW_INDEX_VIDEO_PRODUCTION_TWO_LIST: (state, { list }) => {
    state.newIndexVideoProductionTwoList = list;
  },
  SET_NEW_INDEX_VIDEO_PRODUCTION_THREE_LIST: (state, { list }) => {
    state.newIndexVideoProductionThreeList = list;
  },


  //首页(动画制作)
  SET_NEW_INDEX_MAKE_PRODUCTION_LIST: (state, { list }) => {
    state.newIndexMakeProductionList = list;
  },
  SET_NEW_INDEX_MAKE_MODEL_LIST: (state, { list }) => {
    state.newIndexMakeModelList = list;
  },

  SET_INDEX_RIGHT_CHO_LIST: (state, { list }) => {
    state.indexRightChoList = list;
  },

  //列表(作品)
  SET_NEW_PRODUCTION_PAGE: (state, { page }) => {
    state.newProductionPage = page;
  },

  //用户详情
  SET_NEW_USER_DETAIL: (state, { details }) => {
    state.newUserDetail = details;
  },
  //详情(作品)

  SET_RANK_USER_LIST: (state, { list }) => {
    state.rankUserList = list;
  },

  SET_NEW_ARCHIVE_PAGE: (state, { page }) => {
    state.newArchivePage = page;
  },
  SET_NEW_QUESTION_PAGE: (state, { page }) => {
    state.newQuestionPage = page;
  },
  SET_NEW_MODEL_PAGE: (state, { page }) => {
    state.newModelPage = page;
  },

};
